export default "__VITE_ASSET__Caws7y7f__";